"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const config_1 = require("config");
const warn_svg_1 = __importDefault(require("images/utility-icons/warn.svg"));
const utils_1 = require("utils");
const SignError = ({ errorTitle, errorMessage }) => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "esign-error-container", children: [(0, jsx_runtime_1.jsx)("div", { style: { width: '60px', margin: '10px auto 40px' }, children: (0, jsx_runtime_1.jsx)("img", { src: warn_svg_1.default, alt: "red fail icon" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "header-message", children: [(0, jsx_runtime_1.jsx)("h2", { children: errorTitle }), (0, jsx_runtime_1.jsx)("h4", { children: errorMessage })] })] }));
};
const SignErrorBecauseOfStatus = ({ status }) => {
    return ((0, jsx_runtime_1.jsx)(SignError, { errorTitle: `Transaction ${(0, utils_1.capitalizeFirstLetterInEachWord)(status)}`, errorMessage: `Your transaction has been ${status}. Please contact Alphaeon at ${config_1.ALPHAEON_CONTACT_PHONE} for more details.` }));
};
exports.default = (0, react_1.memo)(SignErrorBecauseOfStatus);
